import { render, staticRenderFns } from "./locomotive-washing-details.vue?vue&type=template&id=1871c618&scoped=true"
import script from "./locomotive-washing-details.vue?vue&type=script&lang=js"
export * from "./locomotive-washing-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871c618",
  null
  
)

export default component.exports